import Hash from './Hash.i18n';

export default Hash
export { Hash as Base }
